module.exports = "while (true);"